<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Exercise Slot List</cs-header-title>
  <cs-header-content>
    <div class="controls-row">
      <cs-input class="search-input" iconName="search" autocomplete="off" [(value)]="searchText"
        type="text" name="searchText" inputmode="search" [placeholder]="'Search slots...' | untranslated"
        (input)="handleSearchChanged()" />

      <cs-button tertiary icon="add" (click)="newSlot()">Create Slot</cs-button>
    </div>
  </cs-header-content>
</cs-header>

<cs-content>
  <!-- Error messages -->
  @if (slotErrors.length > 0) {
    <cs-info-card type="error" [dismissible]="false">
      @for (error of slotErrors; track error) {
        <div>{{ error }}</div>
      }
    </cs-info-card>
  }

  <!-- Slot list -->
  <cs-table class="slot-table">
    @for (s of filteredSlots; track s) {
      <cs-table-row clickable (rowClick)="editSlot(s)">
        <cs-table-cell>{{ s.slotName }}</cs-table-cell>
      </cs-table-row>
    }
  </cs-table>
</cs-content>